import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocNotificationState = atom({
  key: "ocNotificationState",
  default: {
    type: "",
    message: "",
  },
  effects_UNSTABLE: [ocPersistAtom],
});
